import { CElement, IElement, TElementID, CLocation } from "@ts/ui-models";
import { fetchData } from "@redux/slices/functionals/request/requestActions";


export const getItems = async (dispatch, itemsIDs: TElementID[]): Promise<CElement[] | null> => {
    const result = await dispatch(
        fetchData({
            key: 'mapPositions',
            url: '/api/v2/items',
            dataBody: {
                where: {
                    logicalId: itemsIDs,
                    isAlive: true,
                },
            },
        })
    );

    if (result?.payload?.data) {
        return result.payload.data.map((item: IElement) => new CElement(item));
    }
    return null;
};
export const getLocation = async (dispatch, locationID: string): Promise<CLocation | null> => {
    const result = await dispatch(
        fetchData({
            key: 'mapPositions',
            url: `/api/v2/location/${locationID}`,
            dataBody: { findAndCount: false, where: { isAlive: true } },
        })
    );

    if (result?.payload?.data) {
        return new CLocation(result.payload.data);
    }
    return null;
};